import { render, staticRenderFns } from "./VideoTagPeople.vue?vue&type=template&id=4c6efdcb&scoped=true&"
import script from "./VideoTagPeople.vue?vue&type=script&lang=js&"
export * from "./VideoTagPeople.vue?vue&type=script&lang=js&"
import style0 from "./VideoTagPeople.vue?vue&type=style&index=0&id=4c6efdcb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6efdcb",
  null
  
)

export default component.exports